(function(window) {
    if ($('.fifty-item').length <= 0) {
        return;
    }

    $jsPrint = $('.js-print');
    $jsCopyUrl = $('.js-copy-url');

    function printHandler(e) {
        e.preventDefault();
        window.print();
    }

    function copyUrlHandler(e) {
        e.preventDefault();
        navigator.clipboard.writeText(window.location.href);
        this.classList.add('copied');
    }

    $jsPrint.on('click', printHandler);
    $jsCopyUrl.on('click', copyUrlHandler);

    let narrowFfimages = document.querySelectorAll(
        '.-narrow.-contact-form .fifty-item__image-wrapper > img'
    );
    if (narrowFfimages) {
        narrowFfimages.forEach(function(img) {
            let outerDiv = img.parentElement.parentElement.scrollHeight;
            $(img).height(outerDiv);
        });
    }
})(window);
